
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/years/[slug]",
      function () {
        return require("private-next-pages/years/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/years/[slug]"])
      });
    }
  